import { createFileRoute } from '@tanstack/react-router'
import { Bot } from 'lucide-react'
import { z } from 'zod'
import { AgentsScreen } from '@/screens/workspace/SCR-007-agents'

export const Route = createFileRoute('/_app/w/$ws/agents')({
  staticData: { screen: {"id":"SCR-007","title":"Agents","group":"Workspace","perm":"memory.read","order":7,"description":"The agents that read and write memory here, and what they may do.", icon: Bot } },
  validateSearch: z.object({ status: z.enum(['active', 'retired']).optional(), a: z.string().max(200).optional() }),
  component: AgentsScreen,
})
